export const ProductRecommendations = "cc67a07c01909eac672d8b5a6b9fbf6299f69b195f62498f1f457934e7db9112";